import { EUROPACE_CAR_VENDORS } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../utils/regex.utils';
import { schemaBigDecimal, schemaInteger } from '../../../utils/schema.utils';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#fahrzeugkauf

    {
        "anbieter": "HAENDLER" | "PRIVAT",
        "beglicheneKosten": schemaBigDecimal,
        "erstzulassungsdatum": "YYYY-MM-DD",
        "kaufpreis": schemaBigDecimal,
        "kw": schemaInteger,
        "laufleistung": schemaInteger,
        "marke": String,
        "modell": String,
        "ps": schemaInteger
    }

*/
export const schemaEuropaceFahrzeugkauf = z.object({
    anbieter: z.optional(z.nativeEnum(EUROPACE_CAR_VENDORS)),
    beglicheneKosten: z.optional(schemaBigDecimal),
    erstzulassungsdatum: z.optional(z.string().regex(regex_iso_date)),
    kaufpreis: z.optional(schemaBigDecimal),
    kw: z.optional(schemaInteger),
    laufleistung: z.optional(schemaInteger),
    marke: z.optional(z.string()),
    modell: z.optional(z.string()),
    ps: z.optional(schemaInteger),
});

export type SchemaEuropaceFahrzeugkauf = z.infer<typeof schemaEuropaceFahrzeugkauf>;
